import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Grid,
  CardContent,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import Card from "components/cards/Card";
import ImageSection from "./events/ImageSection";
import EventInfo from "./events/EventInfo";
import { makeStyles } from "@material-ui/styles";
import { callGetApiWithAuth } from "utils/api";
import RelatedEvents from "./events/RelatedEvents";

export default function EventDetailPage() {
  const classes = useStyles();
  const { eventId } = useParams();
  const history = useHistory();
  const myUser = useSelector((state) => state.auth.user);
  const [event, setEvent] = useState(undefined);
  const [isLoadingProduct, setIsLoadingEvent] = useState(false);
  const [relatedEvents, setRelatedEvents] = useState([]);
  const [isLoadingRelatedProducts, setIsLoadingRelatedEvents] = useState(false);

  useEffect(() => {
    loadEvent();
  }, [myUser, eventId]);
  const loadEvent = () => {
    setIsLoadingEvent(true);
    setEvent(undefined);
    setRelatedEvents([]);
    setIsLoadingRelatedEvents(true);
    callGetApiWithAuth(`events/${eventId}`, onGetEvent, () =>
      setIsLoadingEvent(false)
    );

    //   callGetApiWithAuth(
    //     `events/${eventId}`,
    //     onGetRelatedEvents,
    //     () => setIsLoadingRelatedEvents(false)
    //  );
  };
  const onGetEvent = (data) => {
    setEvent(data.data);
    setTimeout(() => {
      setIsLoadingEvent(false);
    }, 1200);
  };
  const onGetRelatedEvents = (data) => {
    setRelatedEvents(data.data);
    setTimeout(() => {
      setIsLoadingRelatedEvents(false);
    }, 1200);
  };

  return (
    <>
      {!isLoadingProduct ? (
        <>
          <Card className={classes.causeDetails}>
            <Grid container spacing={3} className={classes.eventGrid}>
              <Grid xs={12} md={6} lg={6} sm={6} className={classes.imageG}>
                <ImageSection event={event} />
              </Grid>
              <Grid xs={12} md={6} lg={6} sm={6} className={classes.eventDescriptionG}>
                <EventInfo event={event} />
              </Grid>
              {/* <Grid xs={12}>
            <Divider />
            <RelatedEvents relatedEvents={relatedEvents} />
          </Grid> */}
            </Grid>
          </Card>
        </>
      ) : (
        <div className={classes.loadingRoot}>
          <CircularProgress size={48} />
        </div>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  eventGrid: {
    width: "100%",
    height: "100%",
    margin: 0,
  },
  imageG: {
    display: "flex",
    justifyContent: "center",
    "& div": {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      marginBottom: "0px !important",
      paddingRight: 30,
      "@media (max-width: 1300px)": {
        paddingRight: 15,
      },
      "@media (max-width: 600px)": {
        paddingRight: 0,
      },
    },
    "& img": {
      width: "100% !important",
      maxHeight: "calc(100vh - 300px) !important",
      maxWidth: "100%",
      objectFit: "cover",
    },
  },
  eventDescriptionG: {
    '& .product-list': {
      paddingLeft: 30,
      "@media (max-width: 1300px)": {
        paddingLeft: 15,
      },
      "@media (max-width: 600px)": {
        padding: 0,
      },
    }
  },
  causeDetails: {
    "& .MuiCardContent-root": {
      padding: 60,
      "@media (max-width: 1300px)": {
        padding: 30,
      },
      "@media (max-width: 600px)": {
        padding: 15,
      },
    },
    '& .item-infos .item-img h6': {
      marginTop: 0,
      "@media (max-width: 600px)": {
        marginTop: 15,
      },
    },
  },
  loadingRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
  },
}));
